goog.provide('el8.appchart.actions.medOrderNew');

goog.require('el8.appchart.dialog.ordermed.discontinue');
goog.require('el8.appchart.dialog.ordermed.documentDiscontinue');
goog.require('el8.appchart.dialog.ordermed.txStartDate');
goog.require('el8.appchart.medsMgr');
goog.require('el8.appchart.permissions');
goog.require('el8.uiwidget.deleteConfirm');
goog.require('el8.util.amplitude.prescriptionFormHelpers');
goog.require('el8.ptdata.medOrders');


// TODO NewChartFeed: replace medOrder with this

el8.appchart.actions.medOrderNew = function(opts) {
    opts = opts || {};
    var item = opts.item;
    var fromRA = opts.fromRA || false;
    var menu = [];

    if (item.isRxDownload()) {
        menu.push({
            actionText: 'Remove',
            actionFn: function() {
                el8.uiwidget.deleteConfirm(
                    "downloaded order (which has fills awaiting acknowledgement) AND its fills", // Surescripts order
                    function() { el8.ptdata.medOrders.deleteItem(item); }
                );
            },
            type: 'remove'
        });
        return menu; // No need to do any of the below
    }

    //
    // Failed eRx only
    //
    var latestERx = item.getFulfillmentMgr().getLatestERx();
    if (fromRA && latestERx && latestERx.isError()) {
        //
        // Left
        //

        // "Export"
        menu.push({type: 'heading', actionText: 'Export to Note:'});

        menu.push({
            actionText: 'as HPI',
            actionFn: function() {
                el8.appchart.mgr.notes.addReference({item: item, sectionName: 'problem'});
            },
            indent: true
        });

        menu.push({
            actionText: 'as Meds',
            actionFn: function() {
                el8.appchart.mgr.notes.addReference({item: item});
            },
            indent: true
        });

        //
        // Right
        //

        // "Edit" (or actions)
        // First, previous RA actions buttons
        if (latestERx.isRetriable()) {
            menu.push({
                actionText: 'Resend',
                actionFn: function() {
                    el8.appchart.mainFeeds.reqAct.remove(item);
                    el8.ptdata.medOrders.eRxSingle(item,
                                                   (latestERx.getPharmacyNcpdpid() && latestERx.getPharmacy()) || null,
                                                   latestERx.getServiceLocationId());
                }
            });
        }

        if (!latestERx.isDismissed()) {
            menu.push({
                actionText: 'Dismiss',
                actionFn: function() {
                    el8.ptdata.medOrders.dismissERxError(item, function() {
                        el8.appchart.mainFeeds.reqAct.remove(item);
                    });
                },
                right: true
            });
        }

        // Discontinue
        if (el8.appchart.permissions.allow('prescribeMeds')) {
            menu.push({
                actionText: 'Discontinue',
                actionFn: function() {
                    el8.appchart.dialog.ordermed.discontinue.show({order: item});
                },
                right: true
            });
        }

        // Document Discontinue
        if (item.isThreadActive()) {
            menu.push({
                actionText: 'Document Discontinue',
                actionFn: function() {
                    el8.appchart.dialog.ordermed.documentDiscontinue.show({order: item});
                },
                right: true
            });

            menu.push({
                actionText: 'Set as ' +
                    (item.isThreadPermanent() ? 'Temporary' : 'Permanent') + ' Med',
                actionFn: function() {
                    el8.appchart.medsMgr.toggleThreadPermanence(item.getThreadId());
                },
                right: true
            });
        }

        // "Print"
        menu.push({type: 'line', right: true});

        menu.push({
            actionText: item.getFulfillmentMgr().hasPaperFulfillment() ? 'Re-print Script' : 'Print Script',
            actionFn: function() {
                el8.ptdata.medOrders.printSingle(item);
                return false;
            },
            right: true
        });

        // "Organize"
        menu.push({type: 'line', right: true});

        if (!item.isDocumentMed()) {
            menu.push({
                actionText: 'View Order',
                actionFn: function() {
                    el8.appchart.showItemDetail(item);
                    return false;
                },
                right: true,
                allowReadonly: true
            });
        }

        // "Remove"
        menu.push({type: 'line', right: true});

        menu.push({
           actionText: 'Remove',
           actionFn: function() {
                var confirmStr = el8.ptdata.medOrderFills.orderHasUnsignedFills(item.getId()) ?
                    "medication order (which has fills awaiting acknowledgement) AND its fills from the patient chart" :
                    "medication order";
                el8.uiwidget.deleteConfirm(confirmStr,
                    function() {
                        el8.ptdata.medOrders.deleteItem(item);
                    }
                );
           },
           type: 'remove',
           right: true
        });

        return menu;
    }


    //
    // Normal Rx's
    //

    //
    // left
    //
    // "Send"
    menu.push({type: 'heading', actionText: 'Send:'});

    menu.push({
        actionText: 'Office Message',
        actionFn: function() {
            el8.appshared.message.prePopulateNewMessage({
                toDocId: item.getId()
            });
        },
        indent: true
    });

    // "Export"
    menu.push({type: 'heading', actionText: 'Export to Note:'});

    menu.push({
        actionText: 'as HPI',
        actionFn: function() {
            el8.appchart.mgr.notes.addReference({item: item, sectionName: 'problem'});
        },
        indent: true
    });
    menu.push({
        actionText: 'as Meds',
        actionFn: function() {
            el8.appchart.mgr.notes.addReference({item: item});
        },
        indent: true
    });

    //
    // Normal Right
    //
    // "Edit"
    if (item.isThreadActive()) {
        menu.push({
            actionText: 'Refill',
            actionFn: function() {
                el8.util.amplitude.logStartPrescription('chronological record', el8.appchart.mgr.orderForm.getPrintFormType(item));
                el8.appchart.mgr.orderForm.refillMedOrder(item);
            },
            right: true
        });

        menu.push({
            actionText: 'Change Dose',
            actionFn: function() {
                el8.util.amplitude.logStartPrescription('chronological record', el8.appchart.mgr.orderForm.getPrintFormType(item));
                el8.appchart.mgr.orderForm.changeMedOrder(item);
            },
            right: true
        });

        if (el8.appchart.permissions.allow('prescribeMeds')) {
            menu.push({
                actionText: 'Discontinue',
                actionFn: function() {
                    el8.appchart.dialog.ordermed.discontinue.show({order: item});
                },
                right: true
            });
            if (el8Globals.FEATURES.NewSurescripts && item.isERx() &&
                    !(item.isCanceled()||item.isCancelPending())
                ) {
                menu.push({
                    actionText: 'Cancel this eRx order',
                    actionFn: function() {
                        el8.util.amplitude.logStartCancelRxRequest("chronological record", item.isControlled());
                        el8React.openCancelPrescriptionDialog(item.getId());
                    },
                    right: true
                });
            }
        }
    } else {
        menu.push({
            actionText: 'Reorder',
            actionFn: function() {
                el8.util.amplitude.logStartPrescription('chronological record', el8.appchart.mgr.orderForm.getPrintFormType(item));
                el8.appchart.mgr.orderForm.reOrderMedOrder(item);
            },
            right: true
        });
    }

    menu.push({
        actionText: 'Document Change',
        actionFn: function() {
            var prescribingPhysicianId = item.getPrescribingPhysicianId();
            var prescriberId;
            if (prescribingPhysicianId) {
              prescriberId = prescribingPhysicianId;
            } else {
              prescriberId = el8.data.currUser.isPhysician() ? el8.data.currUser.getStaffId() : null;
            }
            el8.appchart.dialog.ordermed.document.show({
                order: item,
                type: 'DoseChange',
                prescriberId: prescriberId
            });
        },
        right: true
    });

    if (item.isThreadActive()) {
        menu.push({
            actionText: 'Document Discontinue',
            actionFn: function() {
                el8.appchart.dialog.ordermed.documentDiscontinue.show({
                    order: item
                });
            },
            right: true
        });

        menu.push({
            actionText: 'Set as ' +
                (item.isThreadPermanent() ? 'Temporary' : 'Permanent') + ' Med',
            actionFn: function() {
                el8.appchart.medsMgr.toggleThreadPermanence(item.getThreadId());
            },
            right: true
        });
    }

    // "Print"
    if ((!item.isDocumentMed() && item.isThreadActive()) ||
        item.getFulfillmentMgr().isLatestERxSuccess()) {
        menu.push({type: 'line', right: true});
    }

    if (!item.isDocumentMed() && item.isThreadActive()) {
        menu.push({
            actionText: item.getFulfillmentMgr().hasPaperFulfillment() ? 'Re-print Script' : 'Print Script',
            actionFn: function() {
                el8.ptdata.medOrders.printSingle(item);
                return false;
            },
            right: true,
            allowReadonly: true
        });
    }
    if (item.getFulfillmentMgr().isLatestERxSuccess()) {
        menu.push({
            actionText: 'Print Patient Copy',
            actionFn: function() {
                el8.ptdata.medOrders.printCopy([item]);
                return false;
            },
            right: true,
            allowReadonly: true
        });
    }


    // "Organize"
    menu.push({type: 'line', right: true});

    if (!item.isDocumentMed()) {
        menu.push({
            actionText: 'View Order',
            actionFn: function() {
                el8.appchart.showItemDetail(item);
                return false;
            },
            right: true,
            allowReadonly: true
        });
    }

    menu.push({
        actionText: 'Move to Other Med',
        actionFn: function() {
            el8.appchart.medsHx.main.show({
                medOrderId: item.getId(),
                doMoveMerge: true
            });
        },
        right: true
    });

    // Orders for controlled medications cannot be removed
    // to check feature flag here, but gonna leave flag in just in case
    if (!el8Globals.FEATURES.MDToolboxEPCS || !item.getMedication().isControlled()) {
        // "Remove"
        menu.push({type: 'line', right: true});

        menu.push({
           actionText: 'Remove',
           actionFn: function() {
                var confirmStr = el8.ptdata.medOrderFills.orderHasUnsignedFills(item.getId()) ?
                    "medication order (which has fills awaiting acknowledgement) AND its fills from the patient chart" :
                    "medication order";
                el8.uiwidget.deleteConfirm(confirmStr,
                    function() {
                        el8.ptdata.medOrders.deleteItem(item);
                    }
                );
           },
           type: 'remove',
           right: true
        });
    }

    if (el8Globals.READ_ONLY) {
        menu = _.filter(menu, function(item) { return item.allowReadonly; });
    }

    return menu;

};
